module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<li class=\"page-list ")
    ; __append(escapeFn(id))
    ; __append("\" style=\"display: block\">\r\n    <a data-target=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-list-toggle\" style=\"color:var(--main-primary);font-weight: bold\" data-selected-key=\"page_instance\">\r\n        <i class=\"fa pf-carot-left pf-rotate-icon\" aria-expanded=\"true\"></i>\r\n    </a>\r\n    <a data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-list-toggle\" style=\"color:var(--main-primary);font-weight: bold\" data-selected-key=\"page_instance\">")
    ; __append(escapeFn(name))
    ; __append("</a>\r\n    <ul class=\"control-list ")
    ; __append(escapeFn(id))
    ; __append("\" id=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" data-selected-control=\"")
    ; __append(escapeFn(controlId))
    ; __append("\" style=\"display: none;\"></ul>\r\n</li>")
  }
  return __output;

}